import {ReactNode} from "react";
import {Button, ButtonProps} from "@mui/material";
import {styled} from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import ReplayIcon from "@mui/icons-material/Replay";
import LoopIcon from "@mui/icons-material/Loop";
import ClearIcon from "@mui/icons-material/Clear";
import GroupIcon from "@mui/icons-material/GroupOutlined";
import {DeleteIcon} from "../icons/DeleteIcon";

export type ActionButtonIconType = "none" | "check" | "back" | "delete" | "loop" | "clear" | "group";
export type ActionButtonColorType = "primary" | "secondary" | "error";

export interface Props extends ButtonProps {
    icon: ActionButtonIconType;
    color: ActionButtonColorType;
}

export const ActionButton: React.FC<Props> = ({icon, color, children, ...props}) => (
    <StyledButton {...props} variant={props.variant ?? "contained"} startIcon={renderIcon(icon)} color={color}>
        {children}
    </StyledButton>
);

const StyledButton = styled(Button)({
    boxShadow: "none",
    textTransform: "uppercase",
    fontSize: 16,
    padding: "6px 12px",
    lineHeight: 1.5,
    paddingX: "20px",
    paddingY: "20px",
    borderRadius: "6px",
    minWidth: "132px",
    "&:hover": {
        boxShadow: "none",
    },
});

const renderIcon = (icon: ActionButtonIconType): ReactNode => {
    switch (icon) {
        case "none":
            return null;
        case "check":
            return <CheckIcon />;
        case "back":
            return <ReplayIcon />;
        case "delete":
            return <DeleteIcon sx={{stroke: "#ffffff", width: "1.1rem", height: "1.1rem"}} />;
        case "loop":
            return <LoopIcon />;
        case "clear":
            return <ClearIcon />;
        case "group":
            return <GroupIcon />;
        default:
            return null;
    }
};
